// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","577": "__federation_expose_useHostAuthState",}[chunkId] || chunkId) + "-" + {"122": "2c7bfc488a4c79ca","545": "e78a58de1538e2d9","567": "12213868ef265a8e","577": "38ae27adb57ed741",}[chunkId] + ".bundle.js"
}